'use client'
import React, { useEffect } from 'react'
import { t } from 'i18next'
import Text from 'app/app/(client)/components/atoms/Text/Text'
import Icon from 'app/app/(client)/components/atoms/Icon/Icon'
import Button from '../../atoms/Button/Button'
import { getIcon } from 'app/app/(client)/utils/utils'
import { useAppDispatch, useAppSelector } from 'app/app/(client)/hooks/redux-hook'
import { RootState } from '../../../redux/Store'
import { hideToast } from '../../../redux/features/notification/toast-slice'

const Toast: React.FC = () => {
  const dispatch = useAppDispatch()
  const { toasts } = useAppSelector((state: RootState) => state.toast)

  const onClose = (id: string) => {
    dispatch(hideToast({ id }))
  }

  useEffect(() => {
    if (!toasts.length) {
      return
    }
    const timers: NodeJS.Timeout[] = []
    toasts.forEach(toast => {
      const timer = setTimeout(() => {
        dispatch(hideToast({ id: toast.id }))
      }, toast.duration * 1000)
      timers.push(timer)
    })
    return () => {
      timers.forEach(timer => clearTimeout(timer))
    }
  }, [toasts, dispatch])

  if (!toasts.length) {
    return null
  }

  return (
    <div className="fixed bottom-4 sm:left-4 z-50 flex flex-col gap-4 p-2 sm:p-0">
      {toasts.map(toast => (
        <div
          key={toast.id}
          id={`toast-${toast.type}-${toast.id}-wrapper`}
          className={`toast toast--${toast.type}`}
          role="alert"
        >
          <Icon name={getIcon(toast.type)} className={`text-24px toast__icon--${toast.type}`} />
          <Text id={`toast--${toast.type}-message`} className="flex-1">
            {toast.message}
          </Text>
          <Button
            id={`toast-${toast.type}-${toast.id}-close-btn`}
            variant="tertiary"
            size="small"
            className="btn"
            onClick={() => onClose(toast.id)}
            aria-label="Close"
          >
            {t('errors.refresh.modalClose')}
          </Button>
        </div>
      ))}
    </div>
  )
}

export default Toast
